<template>
  <label :class="`bundle bundle-${color}`">
    {{ $t(`mailer.mailing.new_status.${value}`) }}
  </label>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function() {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'moderation': {
            return 'light-blue';
          }
          case 'rejected': {
            return 'error';
          }
          case 'pending': {
            return 'fresh';
          }
          case 'processing': {
            return 'blue';
          }
          case 'processed': {
            return 'pink';
          }
          case 'finished': {
            return 'green';
          }
          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>
